<template>
  <div class="analysis-dialog">
    <el-dialog
      :visible="centerDialogVisible"
      width="40%"
      @close="closeDialog"
      center>
        <div sloat="title" class="analysis-dialog__title">问题反馈</div>
      <div class="analysis-dialog__count">
        <div class="analysis-dialog__count__title">
          <span>题目id :</span>
          <span>{{questionUUid}}</span>
        </div>
        <div class="analysis-dialog__count__describe">
          <span>问题描述:</span>
          <textarea name="" id="" cols="10" rows="5"
            class="analysis-dialog__textarea"
            placeholder="请至少输入5个字符"
            v-model="textError"
          ></textarea>
        </div>
      </div>
      <div class="error" v-if="errorType">*不得少于5个字符</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="analysisClick"
          class="analysis-dialog__button"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { feedBack } from '@/api/pt';
import { CRM_USER } from '@/config/storage';

export default {
  props: {
    centerDialogVisible: {
      required: true,
      default: false,
    },
    questionUUid: {
      required: true,
      default: '',
    },
  },
  data() {
    return {
      textError: '',
      errorType: false,
    };
  },
  methods: {
    closeDialog() {
      this.$emit('update:centerDialogVisible', false);
    },
    analysisClick() {
      if (this.textError.length < 5) this.errorType = true;
      if (this.textError.length >= 5) {
        feedBack({
          teacher_id: (JSON.parse(localStorage.getItem(CRM_USER)) || {}).id,
          question_uuid: this.questionUUid,
          content: this.textError,
        }).then(() => {
          this.$message.success('感谢您的反馈');
          this.closeDialog();
          this.textError = '';
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .analysis-dialog {
    & /deep/ .el-dialog {
      height: 318px;
    }
    .error {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 72px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #F56C6C;
    }
    &__title {
      position: absolute;
      left: 50%;
      top: 28px;
      transform: translateX(-50%);
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 33px;
      letter-spacing: 1px;

    }
    &__count {
      height: 130px;
      margin-top: 30px;
      &__title {
        margin-bottom: 25px;
        span {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        margin-right: 16px;
       }
      }
      &__describe {
       span {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        vertical-align: top;
        margin-right: 16px;
       }
      }
    }
    &__textarea {
      width: 353px;
      height: 80px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #D8DCE6;
    }
    &__button {
      width: 218px;
    }
  }
</style>
